import { memo } from 'react';

import Draggable from 'react-draggable';

import { FiEdit3 } from 'react-icons/fi';
import { TiArrowSortedUp } from 'react-icons/ti';

import { OTooltip } from '@src/shared';

import useFloatingButton from './useFloatingButton';

import styles from './floatingButton.module.scss';

interface IFloatingButtonProps {
  toggle: (position?: { x: number; y: number }) => void;
  position?: { x: number; y: number } | null;
  onPositionChange?: (position: { x: number; y: number } | null) => void;
}

const FloatingButton = (props: IFloatingButtonProps) => {
  const {
    // State
    showTooltip,
    lastSelectedToolIcon,

    // Refs
    nodeRef,
    buttonRef,

    // Handlers
    handleDrag,
    handleClick,
    handleDragEnd,
    handleMouseDown,
    handleDragStart,
    handleMouseLeave,

    // Props
    position,
  } = useFloatingButton(props);

  return (
    <Draggable
      nodeRef={nodeRef}
      axis="both"
      bounds="parent"
      position={position || undefined}
      onStart={handleDragStart}
      onDrag={handleDrag}
      onStop={handleDragEnd}
    >
      <div ref={nodeRef} className={styles.floatingButtonWrapper}>
        <div className={styles.relativeContainer}>
          <OTooltip
            isSmall
            title={showTooltip ? 'Drag to move' : ''}
            placement="top"
            enterDelay={0}
            leaveDelay={0}
            slotProps={{
              transition: {
                timeout: 0,
              },
            }}
          >
            <div
              ref={buttonRef}
              className={styles.extendedButton}
              onClick={handleClick}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
            >
              <div className={styles.buttonContent}>
                <div className={styles.iconWrapper}>
                  {lastSelectedToolIcon || <FiEdit3 />} <TiArrowSortedUp size={30} />
                </div>
              </div>
            </div>
          </OTooltip>
        </div>
      </div>
    </Draggable>
  );
};

export default memo(FloatingButton);
